import React from 'react'
import FacebookCommentsSection from '../marketplace/FacebookCommentsSection'

const FacebookCommentsWrapper: React.FC = () => {
  return (
    <div className="container-xxl">
      <div className="d-flex flex-column">
        {/* Page Header */}
        <div className="card mb-5 mb-xl-8">
          <div className="card-body py-6">
            <div className="d-flex flex-wrap flex-sm-nowrap">
              <div className="flex-grow-1">
                <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                  <div className="d-flex flex-column">
                    <h1 className="text-dark fw-bolder fs-2 mb-1">תגובות על פוסטים</h1>
                    <div className="d-flex flex-wrap fw-semibold fs-6 text-gray-400">
                      צפייה וניהול תגובות מקבוצות על פוסטים שפורסמו מהמערכת
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Comments Section */}
        <FacebookCommentsSection />
      </div>
    </div>
  )
}

export { FacebookCommentsWrapper }
